import type { ReviewStopDisplay } from "@RequestFormV2/components/ReviewPage/sections/ReviewPackingList/useReviewStopDisplay";

type ReviewPackingListStopCellProps = {
  stopKey?: string;
  stopDisplayByKey: Map<string, ReviewStopDisplay>;
};

export default function ReviewPackingListStopCell({ stopKey, stopDisplayByKey }: ReviewPackingListStopCellProps) {
  const detail = stopKey ? stopDisplayByKey.get(stopKey) : undefined;

  if (!detail) return <span>-</span>;

  return (
    <div className="rfv2-review-packing-list__stop-cell">
      {detail.primaryDateTime && <span className="rfv2-review-packing-list__stop-primary">{detail.primaryDateTime}</span>}
      {(detail.portLabel || detail.addressName || detail.streetLine || detail.regionLine) && (
        <div className="rfv2-review-packing-list__stop-address">
          {detail.portLabel && <span className="rfv2-review__field-value">{detail.portLabel}</span>}
          {detail.addressName && <span className="rfv2-review__field-value">{detail.addressName}</span>}
          {detail.streetLine && <span className="rfv2-review__field-value">{detail.streetLine}</span>}
          {detail.regionLine && <span className="rfv2-review__field-value">{detail.regionLine}</span>}
        </div>
      )}
    </div>
  );
}
